'use strict';

var styled = require('styled-components');
var component = require('../Overlay/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const cursorStyle = styled.css `
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
`;
const colorStyle = styled.css `
  color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled.text : undefined)};
  & > small {
    color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled.text : undefined)};
  }
`;
const Container = styled__default.default.div `
  display: inline-block;
`;
const StyledOverlay = styled__default.default(component.Overlay) `
  padding: ${({ theme }) => theme.designTokens.dropdownOverlayPaddingY} 0;
`;
const ItemContainer = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.dropdownItemPaddingY}
    ${({ theme }) => theme.designTokens.dropdownItemPaddingX};
`;
const ItemGroupContainer = styled__default.default.div `
  & h6 {
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  }

  & > div:not(:first-child) {
    padding-left: ${({ theme }) => theme.space.component.x.l};

    small {
      font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    }
  }
`;
const Item = styled__default.default(ItemContainer) `
  ${colorStyle}
  ${cursorStyle}
  :hover,
  &.hover {
    background: ${({ theme }) => theme.designTokens.dropdownItemHoverBackgroundColor};
  }
  :focus,
  &.focus {
    background: ${({ theme }) => theme.designTokens.dropdownItemFocusBackgroundColor};
    outline: none;
  }

  &.focus.hover {
    background: ${({ theme }) => theme.designTokens.dropdownItemHoverFocusedBackgroundColor};
  }
`;
const Styled = {
    Container,
    Overlay: StyledOverlay,
    Item,
    ItemContainer,
    ItemGroupContainer,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
